/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CancelPaymentDto,
  ErrorMessage,
} from '../models';
import {
    CancelPaymentDtoFromJSON,
    CancelPaymentDtoToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models';

export interface CancelPaymentV2Request {
    paymentReference: string;
    locationId: string;
    cancelPaymentDto: CancelPaymentDto;
}

/**
 * 
 */
export class CancelPaymentControllerApi extends runtime.BaseAPI {

    /**
     */
    async cancelPaymentV2Raw(requestParameters: CancelPaymentV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelPaymentDto>> {
        if (requestParameters.paymentReference === null || requestParameters.paymentReference === undefined) {
            throw new runtime.RequiredError('paymentReference','Required parameter requestParameters.paymentReference was null or undefined when calling cancelPaymentV2.');
        }

        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling cancelPaymentV2.');
        }

        if (requestParameters.cancelPaymentDto === null || requestParameters.cancelPaymentDto === undefined) {
            throw new runtime.RequiredError('cancelPaymentDto','Required parameter requestParameters.cancelPaymentDto was null or undefined when calling cancelPaymentV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v2/location/{locationId}/payments/{paymentReference}/cancel`.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters.paymentReference))).replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelPaymentDtoToJSON(requestParameters.cancelPaymentDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelPaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async cancelPaymentV2(requestParameters: CancelPaymentV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelPaymentDto> {
        const response = await this.cancelPaymentV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
